import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { CentralizedGuidelinesForCheckedInSection1 } from "../GuidelinesForCheckedIn/GuidelinesForCheckedInSection1";
import { CentralizedGuidelinesForCheckedInSection2 } from "../GuidelinesForCheckedIn/GuidelinesForCheckedInSection2";

export const CentralizedGuidelinesForCheckedinLuggage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Page Content",
      key: "centralizedGuidelinesForCheckedinLuggagePageContent",
      children: <CentralizedGuidelinesForCheckedInSection1 />
    },
    {
        label: "Page Image",
        key: "centralizedGuidelinesForCheckedinLuggagePageImage",
        children: <CentralizedGuidelinesForCheckedInSection2 />
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
